import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import ErrorBoundary from './components/ErrorBoundary'
import { AuthProvider } from './contexts/AuthContext'
import { initVersionCheck } from './utils/versionCheck'
import App from './App.jsx'
import SmartAppBanner from './components/SmartAppBanner'
import CookieBanner from './components/CookieBanner'
import ImpersonationBanner from './components/ImpersonationBanner'
import { initConsent } from './utils/consent'
import { initOneSignal } from './utils/onesignal'

// Detect stale builds on app resume (WKWebView / PWA cache safety net)
initVersionCheck()

// Re-load analytics if the user previously consented. No-op otherwise.
initConsent()

// Initialize OneSignal Web SDK. No-op inside the native wrapper, where
// the mobile SDK is integrated at the build layer instead.
initOneSignal()

// Register Service Worker for offline map tile caching
// (silently skipped in WKWebView / native app where SW is not supported)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((err) => {
    if (import.meta.env.DEV) console.warn('SW registration failed:', err)
  })
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <SmartAppBanner />
      <CookieBanner />
      <AuthProvider>
        {/* Rendered above the App tree so the banner survives all of
            App.jsx's early-return branches (auth loading, login, etc.).
            Renders nothing unless the super admin is actively impersonating. */}
        <ImpersonationBanner />
        <App />
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>
)
